import { useEffect } from 'react';
import I18n from 'I18n';
import Raven from 'raven-js';
import enviro from 'enviro';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { useTrelloRedirectUrl } from '../../hooks/useTrelloRedirectUrl';
import * as TrelloApi from './TrelloApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrelloServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout,
  url
}) => {
  const {
    redirectUrl,
    error: redirectUrlError,
    loading: redirectUrlLoading
  } = useTrelloRedirectUrl({
    skip: !reconnectStarted,
    url
  });
  useEffect(() => {
    if (redirectUrlError) {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: redirectUrlError,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    }
  }, [redirectUrlError, onAuthFailed]);
  const handleAuthSucceeded = code => {
    void TrelloApi.installTrello(code).then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      if (enviro.isQa()) {
        console.error(err);
      }
      Raven.captureException(err, {
        extra: {
          message: 'Error on authentication of Trello'
        }
      });
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: err,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    });
  };
  return /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted && !redirectUrlLoading,
    timeout: timeout,
    url: redirectUrl
  });
};